/**
 * bassWell — heavy, dark, bass-pumped tunnel. Reuses the rich legacy_phase0
 * shader path because we want all the warp ingredients available, but biases
 * the params for slow, deep motion. Bass extends the trail length; beats
 * push the chroma and center drift.
 */

import { WarpKind, type VisualizerPreset } from '../presetTypes';

export const bassWellPreset: VisualizerPreset = {
  id: 'bassWell',
  name: 'Bass Well',
  seed: {
    kind: 'waveform',
    params: {
      baseY: 0.0,
      gain: 0.55,
      halfThick: 0.014,
      intensity: 0.4,
      color: [0.95, 0.4, 0.55], // dim coral
      edgeSharp: 8.0,
    },
  },
  warp: {
    kind: WarpKind.LegacyPhase0,
    params: {
      baseZoom: 0.012,
      bassZoomGain: 0.075,
      rotation: 0.0015,
      bassRotationGain: 0.018,
      ripple: 0.002,
      rippleFreq: 4.5,
      decay: 0.972,
      chroma: 0.0035,
      hueShift: 0.008,
      beatPunch: 0.12, // big, satisfying kick punch
      centerDriftAmp: 0.04,
      centerDriftRate: 0.07,
    },
  },
  modulation: [
    // Bass pushes chroma on beats; the old "raise decay on bass" binding
    // was the saturation culprit (no cap existed). Bass reactivity now
    // comes from seed.intensity + beatPunch, both of which are bounded.
    {
      target: 'warp.chroma',
      source: 'beatConfidence',
      transform: 'smoothPulse',
      amount: 0.005,
      smoothingMs: 200,
    },
    {
      target: 'warp.centerDriftAmp',
      source: 'beatConfidence',
      transform: 'linear',
      amount: 0.05,
      smoothingMs: 450,
    },
    {
      target: 'seed.intensity',
      source: 'bass',
      transform: 'smoothPulse',
      amount: 0.3,
      smoothingMs: 90,
    },
  ],
  transition: { durationMs: 1200 },
};
